import { Card } from '@lifebit-ai/lds'
import React from 'react'

import ResultLabels from 'modules/resultsV2/components/ResultLabels'
import { CardBody, CardHeading } from 'ui/card/card.styles'

export const REQUEST_LABELS_CARD_TEST_ID = 'request-labels-card'

export type RequestLabelsCardProps = React.ComponentProps<typeof ResultLabels>

/**
 * Labels presented as a titled card so they sit alongside the request's other context in the
 * rail, rather than as a loose row above the request itself.
 */
export const RequestLabelsCard = (props: RequestLabelsCardProps): JSX.Element => (
  <Card data-testid={REQUEST_LABELS_CARD_TEST_ID}>
    <CardBody>
      <CardHeading>Labels</CardHeading>
      <ResultLabels {...props} />
    </CardBody>
  </Card>
)

export default RequestLabelsCard
